// @ts-nocheck

export default (color: string, opacity: string = 'ff'): string | null => {
  if (/^#[0-9a-fA-F]{6}$/.test(color)) {
    if (/^[0-9a-fA-F]{2}$/.test(opacity)) {
      return color + opacity;
    }
    return color + 'ff';
  }
};
